import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";

export class EventTypeService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/eventnotificationeventtypes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data
      .sort((a,b) => a.eventTypeSortOrder - b.eventTypeSortOrder)
      .reduce((acc: Model[], curr: Model) => {
        const existing = acc.find(x => x.eventTypeCode === curr.eventTypeCode);
        if (!existing) {
          return [ 
            ...acc,
            { 
              id: Number.parseInt(curr.eventTypeCode), 
              label: curr.eventTypeName,
              eventTypeCode: curr.eventTypeCode,
              active: curr.active
            } 
          ];
        }
        return acc;
      }, []);
  }
}

export class EventCommunicationTypeService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/engagementeventmeansofcommunicationtypes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

